import initialState from "./initialState";

export function SpmlAssignmentReducer(
  state = initialState.spmlAssignmentParams,
  action
) {
  switch (action.type) {
    case "SPML_ASSIGNMENT_REQUEST":
      return  action.payload;
    
    default:
      return state;
  }
}